export const calculateMembershipTotalPrice = (data, currentCurrency) => {
  let val = 0;
  let newUser = 0;
  let oldUser = 0;

  //type
  //1 === newUser
  //2 === oldUser
  //3 === exist
  data.forEach((dt) => {
    let pck = dt.package;
    let price = pck.price.value;

    let discount = pck.price.discount;

    let fPrice = currentCurrency === 'IQD' ? pck.price.iqd : (price / 100) * (100 - discount);


    if (dt.type === 0 && price !== 0) {
      newUser++;
    } else {
      oldUser++;
    }

    if (dt.tempNumberOrder === -1) {
      val += fPrice || 0;
    }

  });
  return { finalPrice: val, newUser, oldUser };
};
